import { ViewModel, View, ObservableArray, ViewModelMessage } from "binder";
import { ButtonElement } from "../components/button/button-viewModel";
import { CheckboxElement } from "../components/checkbox/checkbox-viewModel";
import { ClientFilterTableElement } from "../components/clientFilterTable/clientFilterTable-viewModel";
import { ServerFilteringTableViewModel } from "../components/clientFilterTable/serverFilteringTable-viewModel";
import { ComboViewModel } from "../components/combo/combo-viewModel";
import { ContentElement } from "../components/content/content-viewModel";
import { DataViewModel } from "../components/date/data-viewModel";
import { DummyPlaceHolderElement } from "../components/dummyPlaceHolder/dummyPlaceHolder-viewModel";
import { DummyTablePlaceHolderComponentElement } from "../components/dummyPlaceHolder/dummyTablePlaceHolderComponent/dummyTablePlaceHolderComponent-viewModel";
import { TdElement } from "../components/dummyPlaceHolder/dummyTablePlaceHolderComponent/td/td-viewModel";
import { GridViewModel } from "../components/grid/grid-viewModel";
import { HrViewModel } from "../components/hr/hr-viewModel";
import { InputElement } from "../components/input/input-viewModel";
import { ListViewModel } from "../components/list/list-viewModel";
import { LoadingViewModel } from "../components/loading/loading-viewModel";
import { MultiLineInputViewModel } from "../components/multiLineInput/multiLineInput-viewModel";
import { ScrollViewModel } from "../components/scroll/scroll-viewModel";
import { SpanElement } from "../components/span/span-viewModel";
import { CompiledClass } from "../datamodel/classGenerator";
import { ElementCompactViewView } from "../formBuilder/templateEditor/structureView/elementCompactView-view";
import { ReDeclarer } from "../utilities/utilities";
import { AttachedProperty, EventProperty, FormBuilderComponent, Property } from "./components";
import { StringPropertyType } from "./propertyTypes/propetyTypes";
import { BindingPropertyValue, ElementPropertyValue, FormBuilderElementPropertyInvalidStatusChangedMessage, StaticPropertyValue, UnsetPropertyValue } from "./propertyValue";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { FilesListViewModel } from "../components/filesList/filesList-viewModel";
import { ImageElement } from "../components/image/image-viewModel";
import { IconElement } from "../components/icon/icon-viewModel";
import { ITemplateSelector } from "src/uicomponents/components/templateSelector";
import { ExpanderViewModel } from "../components/expander/expander-viewModel";
import { BarcodeReaderViewModel } from "../components/barcodeReader/barcodeReader-viewModel";
import { ChartElement } from "../components/chart/chart-viewModel";
import { GuageElement } from "../components/guage/guage-viewModel";

export class FormBuilderElementDummyBase extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set self(v: FormBuilderElement) { this._self = v; } public get self(): FormBuilderElement { return this._self;} private _self: FormBuilderElement;
    public set decoratorHead(v: FormBuilderElement) { this._decoratorHead = v; } public get decoratorHead(): FormBuilderElement { return this._decoratorHead;} private _decoratorHead: FormBuilderElement;
}

export abstract class FormBuilderElement extends FormBuilderElementDummyBase{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.properties = ObservableArray.create<ElementProperty>();
    }
    hasPropertyWithError():boolean{
        let invalidProperties = this.properties.filter(x=>x.isInvalid==true);
        if(invalidProperties.length>0){
            return true;
        }
        return false;
    }
    public set DataContext(v: CompiledClass) { this._DataContext = v; this.onDataContextSet();} public get DataContext(): CompiledClass { return this._DataContext;} private _DataContext: CompiledClass;
    public set component(v: FormBuilderComponent) { 
        this._component = v; 
        if(v) this.typeName=v.name;
        else this.typeName = '';
    } public get component(): FormBuilderComponent { return this._component;} private _component: FormBuilderComponent;
    public set properties(v: ObservableArray<ElementProperty>) { this._properties = v; } public get properties(): ObservableArray<ElementProperty> { return this._properties;} private _properties: ObservableArray<ElementProperty>;
    public set typeName(v: string) { this._typeName = v; } public get typeName(): string { return this._typeName;} private _typeName: string;
    
    public set Class(v: string) { this._Class = v; } public get Class(): string { return this._Class;} private _Class: string;
    public set Style(v: string) { this._Style = v; this.updateFontParts(); } public get Style(): string { return this._Style;} private _Style: string;
    
    public set FontSize(v: string) { this._FontSize = v; this.updateStyle(); } public get FontSize(): string { return this._FontSize;} private _FontSize: string;
    public set FontFamily(v: string) { this._FontFamily = v; this.updateStyle();} public get FontFamily(): string { return this._FontFamily;} private _FontFamily: string;
    public set FontWeight(v: string) { this._FontWeight = v; this.updateStyle();} public get FontWeight(): string { return this._FontWeight;} private _FontWeight: string;
    public set FontStyle(v: string) { this._FontStyle = v;this.updateStyle(); } public get FontStyle(): string { return this._FontStyle;} private _FontStyle: string;
    public set TabIndex(v: number) { this._TabIndex = v; } public get TabIndex(): number { return this._TabIndex;} private _TabIndex: number;
    public set Tooltip(v: string) { this._Tooltip = v; } public get Tooltip(): string { return this._Tooltip;} private _Tooltip: string;
    public set TooltipTemplateSelector(v: string) { this._TooltipTemplateSelector = v; } public get TooltipTemplateSelector(): string { return this._TooltipTemplateSelector;} private _TooltipTemplateSelector: string;
    public set TemplateSelectorFunctionForInterface(v: ITemplateSelector) { this._TemplateSelectorFunctionForInterface = v; } public get TemplateSelectorFunctionForInterface(): ITemplateSelector { return this._TemplateSelectorFunctionForInterface;} private _TemplateSelectorFunctionForInterface: ITemplateSelector;
    
    private isUpdatingStyle : boolean;

    
    updateStyle(){
        if(this.isUpdatingStyle===true)
            return;
        this.isUpdatingStyle = true;    
        let keyValue : Map<string,string> = new Map<string,string>();
        this.Style.split(";").forEach(x=>{
            let parts = x.split(':');
            if(parts.length==2){
                keyValue.set(parts[0],parts[1]);
            }
        });
        if(stringIsNullOrEmpty(this.FontFamily) || this.FontFamily.toLowerCase()=='unset'){
            keyValue.delete('font-family');
        }else{
            keyValue.set('font-family',this.FontFamily);
        }
        if(stringIsNullOrEmpty(this.FontSize) || this.FontSize.toLowerCase()=='unset'){
            keyValue.delete('font-size');
        }else{
            keyValue.set('font-size',this.FontSize);
        }
        if(stringIsNullOrEmpty(this.FontWeight) || this.FontWeight.toLowerCase()=='unset'){
            keyValue.delete('font-weight');
        }else{
            keyValue.set('font-weight',this.FontWeight);
        }
        if(stringIsNullOrEmpty(this.FontStyle) || this.FontStyle.toLowerCase()=='unset'){
            keyValue.delete('font-style');
        }else{
            keyValue.set('font-style',this.FontStyle);
        }
        let value = [...keyValue.keys()].map(x=>`${x}:${keyValue.get(x)}`).join(";");
        this.findPropertyByName("Style").setStaticValue(value);
        this.findPropertyByName("Style").onChangeInternally();
        this.isUpdatingStyle = false;
    }

    updateFontParts(){
        if(this.isUpdatingStyle===true)
            return;
        this.isUpdatingStyle = true;    
        let fontFamilyFound = false;
        let fontSizeFound = false;
        let fontWeightFound = false;
        let fontStyleFound = false;
        this.Style.split(";").forEach(x=>{
            let parts = x.split(':');
            switch(parts[0].trim().toLowerCase()){
                case 'font-family':
                    this.findPropertyByName("FontFamily").setStaticValue(parts[1]);
                    this.findPropertyByName("FontFamily").onChangeInternally();
                    fontFamilyFound = true;
                    break;
                case 'font-size':
                    this.findPropertyByName("FontSize").setStaticValue(parts[1]);
                    this.findPropertyByName("FontSize").onChangeInternally();
                    fontSizeFound = true;
                    break;
                case 'font-weight':
                    this.findPropertyByName("FontWeight").setStaticValue(parts[1]);
                    this.findPropertyByName("FontWeight").onChangeInternally();
                    fontWeightFound = true;
                    break;
                case 'font-style':
                    this.findPropertyByName("FontStyle").setStaticValue(parts[1]);
                    this.findPropertyByName("FontStyle").onChangeInternally(); 
                    fontStyleFound = true;
                    break;
            }
        });
        if(fontFamilyFound==false){
            this.findPropertyByName("FontFamily")?.unsetValue();
            this.findPropertyByName("FontFamily")?.onChangeInternally(); 
        }
        if(fontSizeFound==false){
            this.findPropertyByName("FontSize")?.unsetValue();
            this.findPropertyByName("FontSize")?.onChangeInternally(); 
        }
        if(fontWeightFound==false){
            this.findPropertyByName("FontWeight")?.unsetValue();
            this.findPropertyByName("FontWeight")?.onChangeInternally(); 
        }
        if(fontStyleFound==false){
            this.findPropertyByName("FontStyle")?.unsetValue();
            this.findPropertyByName("FontStyle")?.onChangeInternally(); 
        }

        this.isUpdatingStyle = false;
    }

    findProperty(property : Property):ElementProperty{
        let found = this.properties.filter(x=>x.property==property)
        if(found.length>0){
            return found[0];
        }
        return null;
    }
    findPropertyByName(propertyName : string):ElementProperty{
        let found = this.properties.filter(x=>x.property.name==propertyName)
        if(found.length>0){
            return found[0];
        }
        return null;
    }
    isPropertyRegistered(property : Property){
        if(this.findProperty(property)==null)
            return false;
        return true;
    }

    UnsetPropertyValue(property: Property) {
        let elementProperty = this.registerProperty(property);
        elementProperty.unsetValue();
    }
    registerProperty(property : Property) : ElementProperty{
        if(this.isPropertyRegistered(property)==true)
            return this.findProperty(property);

        let elementProperty = new ElementProperty(this);
        elementProperty.property = property;
        elementProperty.element = this;
        elementProperty.unsetValue();
        this.properties.push(elementProperty);
        return elementProperty;
    }
    registerAttached(property : Property,targetElement:FormBuilderElement) : ElementProperty{
        if(this.isPropertyRegistered(property)==true)
            return this.findProperty(property);

        let elementProperty = new ElementAttachedProperty(this);
        elementProperty.property = property;
        elementProperty.element = this;
        elementProperty.targetElement = targetElement;
        elementProperty.unsetValue();
        this.properties.push(elementProperty);
        return elementProperty;
    }
    unregisterAttacheds(){
        let attachedProperties = this.properties.filter(x=>x instanceof ElementAttachedProperty);
        this.properties.remove(...attachedProperties);
    }
    abstract Accept(visitor : IFormBuilderElementVisitor,parameter:object) : object;
    canAcceptContent():Boolean{
        return false;
    }
    canAcceptContentAtDeserializationTime(){
        return this.canAcceptContent();
    }
    onDataContextSet(){
        this.TemplateSelectorFunctionForInterface = this.DataContext._Builder_TemplateSelector__;
    }

    async removeElementFromParent(){
        let parent : ChildAcceptableFormBuilderElement = await this.handleMessage(new FindMyParentMessage(this));
        if(parent)
            parent.removeChild(this.decoratorHead);
    }

    getCompactViewForFormBuilderStructureViewDecorators(vm){
        return new ElementCompactViewView();
    }
}
export class FindMyParentMessage extends ViewModelMessage{
    public self:FormBuilderElement;
    constructor(self:FormBuilderElement) {
        super();
        this.self=self;
    }
}
export class ElementDecorator extends FormBuilderElementDummyBase{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set decoratorComponent(v: FormBuilderElement) { 
        this._decoratorComponent = v; 
        if(v)
            new ReDeclarer().redeclare(v,this);
    } public get decoratorComponent(): FormBuilderElement { return this._decoratorComponent;} private _decoratorComponent: FormBuilderElement;
 
    public set self(v: FormBuilderElement) { this.decoratorComponent.self = v; } public get self(): FormBuilderElement { return this.decoratorComponent.self;}
    public set decoratorHead(v: FormBuilderElement) { this.decoratorComponent.decoratorHead = v; } public get decoratorHead(): FormBuilderElement { return this.decoratorComponent.decoratorHead;}
    public set compactViewModelType(v: ViewModel) { this._compactViewModelType = v; } public get compactViewModelType(): ViewModel { return this._compactViewModelType;} private _compactViewModelType: ViewModel;
}
export abstract class ChildAcceptableFormBuilderElement extends FormBuilderElement{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.children = ObservableArray.create<FormBuilderElement>();
    }
    public set children(v: ObservableArray<FormBuilderElement>) { this._children = v; } public get children(): ObservableArray<FormBuilderElement> { return this._children;} private _children: ObservableArray<FormBuilderElement>;
    abstract Accept(visitor : IFormBuilderElementVisitor,parameter:object) : object;
    addChild(element:FormBuilderElement,mouseEvent:MouseEvent=null){
        element.DataContext = this.DataContext;
        this.addChildInternal(element,mouseEvent);
    }
    abstract addChildInternal(element:FormBuilderElement,mouseEvent?:MouseEvent):void;
    abstract removeChild(element:FormBuilderElement):void;

    override canAcceptContent():Boolean{
        return true;
    }
    handleMessage(msg:ViewModelMessage){
        if(msg instanceof FindMyParentMessage && msg.self.self!=this.self){
            return this;
        }else{
            return super.handleMessage(msg);
        }
    }

}

export interface IFormBuilderElementVisitor{
    VisitBarcodeReader(arg0: BarcodeReaderViewModel, parameter: object): object;
    VisitExpander(arg0: ExpanderViewModel, parameter: object): object;
    VisitScroll(arg0: ScrollViewModel, parameter: object): object;
    VisitMultiLineInput(arg0: MultiLineInputViewModel, parameter: object): object;
    VisitLoading(arg0: LoadingViewModel, parameter: object): object;
    VisitList(arg0: ListViewModel, parameter: object): object;
    VisitHr(arg0: HrViewModel, parameter: object): object;
    VisitDate(arg0: DataViewModel, parameter: object): object;
    VisitCheckBox(arg0: CheckboxElement, parameter: object): object;
    VisitButton(arg0: ButtonElement, parameter: object): object;
    VisitClientFilterTable(arg0: ClientFilterTableElement, parameter: object): object;
    VisitDummyTablePlaceHolderComponentElement(arg0: DummyTablePlaceHolderComponentElement, parameter: object): object;
    VisitTdElement(arg0: TdElement, parameter: object): object;
    VisitSpan(arg0: SpanElement, parameter: object): object;
    VisitComboBox(arg0: ComboViewModel, parameter: object): object;
    VisitGrid(arg0: GridViewModel, parameter: object): object;
    VisitDummyPlaceHolder(arg0: DummyPlaceHolderElement, parameter: object): object;
    VisitInput(arg0: InputElement, parameter: object): object;
    VisitContent(arg0: ContentElement, parameter: object): object;
    VisitServerFilterTable(arg0: ServerFilteringTableViewModel, parameter: object): object;
    VisitFilesList(arg0: FilesListViewModel, parameter: object): object;
    VisitImage(arg0: ImageElement, parameter: object): object;
    VisitIcon(arg0: IconElement, parameter: object): object;
    VisitChart(arg0: ChartElement, parameter: object): object;
    VisitGuage(arg0: GuageElement, parameter: object): object;
}


export class ElementProperty extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.isInvalid = false;
    }
    public set element(v: FormBuilderElement) { this._element = v; } public get element(): FormBuilderElement { return this._element;} private _element: FormBuilderElement;
    public set property(v: Property) { this._property = v; } public get property(): Property { return this._property;} private _property: Property;
    public set value(v: any) { this._value = v; } public get value(): any { return this._value;} private _value: any;
    public set elementPropertyValue(v: ElementPropertyValue) { 
        this._elementPropertyValue = v; 
        if(v && v.isValid()!=!this.isInvalid){
            this.isInvalid = !v.isValid;
            this.handleMessage(new FormBuilderElementPropertyInvalidStatusChangedMessage(this.isInvalid,v));
        }
    } public get elementPropertyValue(): ElementPropertyValue { return this._elementPropertyValue;} private _elementPropertyValue: ElementPropertyValue;
    public set isInvalid(v: boolean) { 
        let shallRaise = false;
        if(this.isInvalid!=null && this.isInvalid!=v){
            shallRaise = true;
        }
        this._isInvalid = v; 
        if(shallRaise){
            this.validationStatusChanged(this.isInvalid);
        }
        
    } public get isInvalid(): boolean { return this._isInvalid;} private _isInvalid: boolean;
    
    public validationStatusChanged(isInvalid:boolean){

    }

    unsetValue(){
        this.elementPropertyValue?.dispose();
        this.elementPropertyValue = new UnsetPropertyValue(this);
        this.elementPropertyValue.setValue(null)
    }

    setStaticValue(value:any){
        this.elementPropertyValue?.dispose();
        this.elementPropertyValue = new StaticPropertyValue(this);
        this.elementPropertyValue.setValue(value)
    }

    setBinding(value:any){
        this.elementPropertyValue?.dispose();
        this.elementPropertyValue = new BindingPropertyValue(this);
        this.elementPropertyValue.setValue(value)
    }

    UpdateTargetElementValue(value: object) {
        this.getTargetElement()[this.property.name] = value;
    }

    getTargetElement() : FormBuilderElement {
        return this.element;
    }
    handleMessage(msg:ViewModelMessage){
        if(msg instanceof FormBuilderElementPropertyInvalidStatusChangedMessage){
            this.isInvalid = msg.isInvalid;
            return super.handleMessage(msg);
        }else{
            return super.handleMessage(msg);
        }
    }
    onChangeInternally(){

    }
}

export class CustomElementProperty extends ElementProperty{
    static removeProperty(element: FormBuilderElement, name: string) {
        let relatedProperty = element.findPropertyByName(name);
        element.properties.remove(relatedProperty);
    }
    public static createProperty(element:FormBuilderElement,readableName:string):CustomElementProperty{
        return CustomElementProperty.createPropertyWithName(element,readableName);
    }
    public static createPropertyWithName(element:FormBuilderElement,readableName:string,name?:string):CustomElementProperty {
        if(name==null){
            name = `CUSTOM-PROPERTY-${readableName}`;
            let existingProperties = element.properties.map(x=>x.property).filter(x=>x.name.startsWith(name));
            let lastIndex = existingProperties.map(x=>parseInt(x.name.substring(name.length+1))).reduce((a,c)=>a>c?a:c,0);
            let newIndex = lastIndex +1;
            name = `CUSTOM-PROPERTY-${readableName}-${newIndex}`;
        }
        if(element[`_${name}`]==undefined){
            try{
                element[`_${name}`]=null;
                Object.defineProperty(element,name,{
                    get : function(){return this[`_${name}`]}.bind(element),
                    set : function(v){this[`_${name}`]=v}.bind(element),
                });
            }catch{

            }
        }


        let elementProperty = new CustomElementProperty(element);
        elementProperty.element = element;
        let property : Property;
        if(readableName.trim().startsWith('data-b-event-')){
            property = new EventProperty(element);
            property.propertyType = new StringPropertyType(property);

        }else{
            property = new Property(element);
            property.propertyType = new StringPropertyType(property);

        }
        property.attributeName = readableName;
        elementProperty.property = property;
        property.name = name;
        property.readableName = readableName;
        property.canBeContent = false;
        property.component = element.component;
        property.defaultValue = <any>"";
        property.attributeName = readableName;
        elementProperty.unsetValue();
        element.properties.push(elementProperty);
        return elementProperty;
    }
}

export class ElementAttachedProperty extends ElementProperty{
    public set targetElement(v: FormBuilderElement) { this._targetElement = v; } public get targetElement(): FormBuilderElement { return this._targetElement;} private _targetElement: FormBuilderElement;
    
    getTargetElement() : FormBuilderElement {
        return this.targetElement;
    }
    UpdateTargetElementValue(value: object) {
        this.targetElement[this.property.name]=value;
    }
}


export abstract class FormBuilderComponentView<T extends FormBuilderElement> extends View<T>{
    constructor() {
        super();
        try{
            this['_Class']=null;
            Object.defineProperty(this,'Class',{
                set : function(v){this['_Class']=v;}.bind(this),
                get : function(){return this['_Class']}.bind(this),
                configurable:true
            })

            this['_Style']=null;
            Object.defineProperty(this,'Style',{
                set : function(v){this['_Style']=v;}.bind(this),
                get : function(){return this['_Style']}.bind(this),
                configurable:true
            })

            this['_FontSize']=null;
            Object.defineProperty(this,'FontSize',{
                set : function(v){this['_FontSize']=v;}.bind(this),
                get : function(){return this['_FontSize']}.bind(this),
                configurable:true
            })

            this['_FontFamily']=null;
            Object.defineProperty(this,'FontFamily',{
                set : function(v){this['_FontFamily']=v;}.bind(this),
                get : function(){return this['_FontFamily']}.bind(this),
                configurable:true
            })
            
            this['_FontWeight']=null;
            Object.defineProperty(this,'FontWeight',{
                set : function(v){this['_FontWeight']=v;}.bind(this),
                get : function(){return this['_FontWeight']}.bind(this),
                configurable:true
            })
            
            this['_FontStyle']=null;
            Object.defineProperty(this,'FontStyle',{
                set : function(v){this['_FontStyle']=v;}.bind(this),
                get : function(){return this['_FontStyle']}.bind(this),
                configurable:true
            })

            this['_TabIndex']=null;
            Object.defineProperty(this,'TabIndex',{
                set : function(v){this['_TabIndex']=v;}.bind(this),
                get : function(){return this['_TabIndex']}.bind(this),
                configurable:true
            })
            
            this['_Tooltip']=null;
            Object.defineProperty(this,'Tooltip',{
                set : function(v){this['_Tooltip']=v;}.bind(this),
                get : function(){return this['_Tooltip']}.bind(this),
                configurable:true
            });
            
            this['_TooltipTemplateSelector']=null;
            Object.defineProperty(this,'TooltipTemplateSelector',{
                set : function(v){this['_TooltipTemplateSelector']=v;}.bind(this),
                get : function(){return this['_TooltipTemplateSelector']}.bind(this),
                configurable:true
            });

        }catch{}
    }
}
